(function () {
  const initProductAccordion = () => {
    // Collapse all accordion content at the start
    $('.about__accordion-description').hide();
    $('.about__accordion-toggle').removeClass('active');

    // Add click event listener to toggles
    $('.about__accordion-toggle').on('click', function () {
      const toggle = $(this);
      const description = toggle.siblings('.about__accordion-description').eq(toggle.index());

      if (!toggle.hasClass('active')) {
        // Close other open accordions
        $('.about__accordion-toggle.active').removeClass('active');
        $('.about__accordion-description').stop().slideUp(300);

        // Open the selected accordion
        toggle.addClass('active');
        description.stop().slideDown(300);
      } else {
        // Close the currently active accordion
        toggle.removeClass('active');
        description.stop().slideUp(300);
      }
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper?.querySelectorAll('.js-image-zoom');

    images?.forEach((el) => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    });
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
  });

  initProductAccordion();
  initZoomImage();
})();
